import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { WalletProvider } from '@/contexts/WalletContext';
import { GameProvider } from '@/contexts/GameContext';
import { ToastProvider } from '@/contexts/ToastContext';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <WalletProvider>
        <GameProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </GameProvider>
      </WalletProvider>
    </BrowserRouter>
  </React.StrictMode>
);
